import { LIST_GEOGRAPHIC_LOCATIONS } from '../constants/geographic_location_constants';
import { sendRequest, completeRequest, errorOnRequest } from './request_state';
import RequestService from '../services/request_service';

const nodeRequestService = new RequestService('node');

function setGeographicLocations(data, meta) {
  return {
    type: LIST_GEOGRAPHIC_LOCATIONS,
    data,
  };
}

export const fetchGeographicLocations = (params = {}) => async dispatch => {
  dispatch(sendRequest());
  try {
    const payload = await nodeRequestService.get('geographic-location', {}, true);
    dispatch(setGeographicLocations(payload.data.geographicLocations));
  } catch (errors) {
    // console.log(errors);
  } finally {
    dispatch(completeRequest());
  }
};
